import { z } from 'zod';

export enum TaskPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export const taskPrioritySchema = z.nativeEnum(TaskPriority);
